// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"9e199aff","73":"f483ec60","74":"33910f94","87":"ba9f8748","181":"8c1b6ef0","268":"b493ff2c","352":"526c7772","358":"35dbf86a","684":"d7d416ae","890":"5f57bccb"}[chunkId] + ".chunk.js";
};